import { USE_PRODUCT_FAILURE, USE_PRODUCT_REQUEST, USE_PRODUCT_SUCCESS } from 'actions/product/saveUseProduct.types';
import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';

const saveUseProduct = ({ salonId, productId, quantity }) => ({
  ATAG: 'saveUseProduct',
  [AUTH_API]: {
    ...authenticatedEndpoint({ root: CONF.stockApiRoot }),
    ...jsonEndpoint(H.post, `product/salon/${salonId}/used/`, { product_id: productId, quantity }),
    types: [USE_PRODUCT_REQUEST, USE_PRODUCT_SUCCESS, USE_PRODUCT_FAILURE],
  },
});

// noinspection JSUnusedGlobalSymbols
export default saveUseProduct;
